/**
 * Development build targeting the test aggregator backend (remote API).
 *
 * Use: `ng serve --configuration=development-testaggregator`
 * or `npm run start:testaggregator`.
 *
 * `frontendUrl` is the dev server origin; API, docs, and Django admin use testaggregator.
 */
export const environment = {
  production: false,
  apiUrl: 'https://testaggregator.mainmoney.net/api/v1',
  frontendUrl: 'http://localhost:4200',
  documentationUrl: 'https://testaggregator.mainmoney.net/api/v1/docs/merchants',
  internalDocumentationUrl: 'https://testaggregator.mainmoney.net/api/v1/docs/internal',
  adminUrl: 'https://testaggregator.mainmoney.net/bd1fdebcd8b376b0',
  turnstileSiteKey: '0x4AAAAAAEmTtB7I5m0aaDpk',
  merchantPortalUrl: 'https://testapiportal.mainmoney.net',
};
